import { type FC, type JSX, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

const paragraph = (chunks: ReactNode[]): JSX.Element => (
  <p className="mb-3">{chunks}</p>
)

export const ProductPageOdsDialogOnlineDoctorSectionNotice: FC = () => (
  <section className="mt-5" id="online-doctor-notice">
    <h3 className="mb-5 font-medium">
      <FormattedMessage id="general.modal.title.important" />
    </h3>
    <div className="text-dark-primary-max">
      <FormattedMessage
        id="pdp.buyboxwithvariants.odsModal.tabs.tab1.onlineDoctorNotice"
        values={{
          paragraph,
        }}
      />
    </div>
  </section>
)
